import CustomGraphy from '@/components/CustomGraphy'

interface PageTitleProps {
  children: React.ReactNode
}

const PageTitle = ({ children, ...props }: PageTitleProps) => {
  return (
    <CustomGraphy mb="24px" fontSize="28px" color="#2E363E" {...props}>
      {children}
    </CustomGraphy>
  )
}

export default PageTitle
